export default "__VITE_ASSET__Do0S8$Zl__"